export class EpbtFaPurchaseOrderLines {
    productCode: string;
    quantity: string;
    lineNumber: string;
    totalCostPrice: number;
    unitCostPrice: string;
    manualCode: string;
    manualValue: number;
    description: string;
    manualValueTypeDescription: string;
}
